<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="welcome">
    <v-row class="max-w">
      <v-col class="px-7 text-center">
        <div><img src="/img/icons/apple-touch-icon-60x60.png" alt="logo" /></div>
        <div class="display-1">{{ $t('witaj') }}</div>
        <div class="subtitle-1 pb-8 w-100 text-center">{{ $t('zacheta') }}</div>
        <div class="text-center">
          <img src="/img/welcome-screen.svg" alt="boiler app" class="d-inline-block w-70" />
        </div>
        <div class="pt-8">
          <v-btn x-large class="w-100 mb-4 t-filled" color="primary" to="/login">{{ $t('zaloguj') }}</v-btn>
          <v-btn x-large class="w-100 btn-secondary mb-4" to="/register">{{ $t('utworz') }}</v-btn>
          <v-btn x-large class="w-100 t-empty" id="btnAdd" style="display:none;">Zainstaluj</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    isLogged() {
      //return localStorage.getItem('login');
      return true;
    }
  },
  beforeCreate() {
    //przekieruj jesli zalogowany
    if (this.$store.state.user.token) {
      this.$router.push({ path: '/controllers' });
    }
  },
  created() {
    /*if (this.isLogged) {
      this.$router.push({ path: '/home' });
    }*/

    //install button
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();

      deferredPrompt = e;
      var btnAdd = document.getElementById('btnAdd');
      console.log('beforeinstallprompt');
      btnAdd.style.display = 'inline-flex';
      btnAdd.addEventListener('click', (e) => {
        // hide our user interface that shows our A2HS button
        btnAdd.style.display = 'none';
        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice
          .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
      });
    })
  },
  /*beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('login')) {
      next('/home');
    }
  }*/
}



</script>

<style>
</style>
